import { NetSuiteClassSchema } from '@vy/types';
import { oz } from '@vy/utils';

export const ProductClassFormInputSchema = NetSuiteClassSchema;

export type ProductClassFormInput = oz.infer<typeof ProductClassFormInputSchema>;
